$(function(){

	var $burger = $('.js-burger'),
	$menu = $('.js-menu');


	$burger.on('click', function() {
		$(this).toggleClass('open');
		$menu.toggleClass('open');
		$('.js-nav-list').toggleClass('open');		
		$('.js-shape').toggleClass('active');
		$('.js-filter').toggleClass('open');
		$('body').toggleClass('body-no-scroll');
		noScroll();
	});

	$('.js-nav-list li').each(function(index) {
		var delay = 0.3 + index*0.075;
		$(this).css('transition-delay', delay+'s');
	});

	maxWidthLg(function(){
			
	}, function(){
		$('.menu-item-has-children a').first().click(function(e){
			var $that = $(this);
			e.preventDefault();
			$that.next().toggleClass('open');
		});

		$('.menu-item-has-children > ul > li > a').click(function(){
			if ($menu.is('.open')) {
				$burger.trigger('click');
			}
		});

		// $(window).on('hashchange', function() {
		// 	if ($menu.is('.open')) {
		// 		$burger.trigger('click');
		// 	}
		// });
	});

});

function noScroll() {
	$(document.body).on('touchmove', function() {
		if($('.js-filter').hasClass('open')) {
		    event.preventDefault();
		    event.stopPropagation();
		} else {
			console.log('scroll');
		}
	});
}